module.exports = __webpack_public_path__ + "img/jx_sample.b3eeb9c5.png";